// Tipo TypeScript inferido del schema
import { z } from "zod";

export const signInFormSchema = z.object({
  email: z.string({ required_error: "Este campo es requerido" }).email({
    message: "Ingrese un correo electrónico válido",
  }),
});
